const consentCategories = ['C0001', 'C0002', 'C0003', 'C0004']

export const cdnSettings = {
  _lastModified: '2025-11-19T16:55:02.290Z',
  endpoint: `/rest/v1/analytics`,
  integrations: {
    'Google Tag Manager': {
      containerId: process.env.NEXT_PUBLIC_GTM_ID || '',
      dataLayerName: '',
      environment: '',
      trackAllPages: true,
      trackCategorizedPages: false,
      trackNamedPages: false,
      versionSettings: {
        version: '2.5.1',
        componentTypes: ['browser' as const],
      },
      type: 'browser',
      consentSettings: { categories: consentCategories },
      bundlingStatus: 'bundled' as const,
    },
    'Segment.io': {
      apiHost: `/rest/v1/analytics`,
      apiKey: 'No key is needed', // we are not using Segment's hosted endpoint
      unbundledIntegrations: [],
      addBundledMetadata: true,
      maybeBundledConfigIds: {},
      versionSettings: {
        version: '4.4.7',
        componentTypes: ['browser' as const],
      },
    },
  },
  plan: {
    track: { __default: { enabled: true, integrations: {} } },
    identify: { __default: { enabled: true } },
    group: { __default: { enabled: true } },
  },
  edgeFunction: {},
  analyticsNextEnabled: true,
  enabledMiddleware: {},
  metrics: { sampleRate: 0.1, host: 'api.segment.io/v1' },
  legacyVideoPluginsEnabled: false,
  remotePlugins: [],
  consentSettings: {
    hasUnmappedDestinations: false,
    allCategories: consentCategories,
  },
  autoInstrumentationSettings: { disableTraffic: false, sampleRate: 0 },
}
